import React from "react";
import axios from "axios";
import "react-table/react-table.css";
import { LinearProgress } from "react-md";
import "../../../node_modules/react-md/dist/react-md.indigo-blue.min.css";
import "bootstrap-datepicker/js/bootstrap-datepicker.js";
import "bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css";
import Loader from "../../_components/loader";
import "react-notifications/lib/notifications.css";
import { AdminUrls } from "../../network/config";
import "./style.css";
import { removeData } from "../../store/action";
import { connect } from "react-redux";

const getCpdHost = AdminUrls.ADMIN.GETUSERDETAILS;

class UserManagment extends React.Component {
  constructor() {
    super();
    this.clearSearchFilters = this.clearSearchFilters.bind(this);
    this.getLoadCpd = this.getLoadCpd.bind(this);
    this.modalData = this.modalData.bind(this);
    this.editCourse = this.editCourse.bind(this);
    this.searchData = this.searchData.bind(this);

    this.state = {
      unauthorized: false,

      loadHost: [],
      dupLoadHost: [],
      username: "",
      sortBy: "",
      editId: "",
      emptyDivMsg: "There is no data to show in the grid.",
      mainLoading: false,
      listViewModalShown: false,
      handleSwitch: false,
      addEditCourseBtn: false,
      search_email: "",
      search_name: "",
      countId: "",
    };
    this.controller = new AbortController();
  }

  componentDidMount() {
    this.getLoadCpd();
  }

  getLoadCpd() {
    this.setState({ mainLoading: true });

    axios
      .get(getCpdHost, {
        method: "GET",
        signal: this.controller.signal,
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          loadHost: data,
          dupLoadHost: data,
          mainLoading: false,
        });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  modalData() {
    this.props.history.push("/register");
  }

  editCourse(id) {
    this.props.history.push(`/register/${id}`);
  }

  clearSearchFilters() {
    this.setState({
      loadHost: this.state.dupLoadHost,
      search_email: "",
      search_name: "",
    });
  }

  searchData(e) {
    let filtValue = e?.target?.value;
    let dup = [...this.state.dupLoadHost];

    if (!filtValue) {
      this.setState({
        loadHost: this.state.dupLoadHost,
        search_email: "",
        search_name: "",
      });
    } else {
      let filteredData = dup?.filter((item) => {
        return (
          item?.Email?.includes(filtValue) ||
          item?.UserName?.includes(filtValue)
        );
      });
      if (e?.target?.id === "name") {
        this.setState({
          loadHost: filteredData,
          search_name: e?.target?.value,
        });
      } else {
        this.setState({
          loadHost: filteredData,
          search_email: e?.target?.value,
        });
      }
    }
  }
  componentWillUnmount() {
    this.controller.abort();
  }
  render() {
    let loadHost;

    if (this.state.loadHost !== null) {
      loadHost = this.state.loadHost?.map((loadHost, index) => {
        return (
          <tr key={index}>
            <td>{loadHost?.UserName}</td>
            <td>{loadHost?.Email}</td>
            <td>{loadHost?.FirstName}</td>
            <td>{loadHost?.Surname}</td>
            <td>{loadHost?.LastLoginTime}</td>
            <td>{loadHost?.EmployerName}</td>

            <td>
              <button
                onClick={() => this.editCourse(loadHost?.UserId)}
                className="button-custom"
              >
                <i className="fa fa-edit icon-tables"> </i>
              </button>
            </td>
          </tr>
        );
      });
    }

    return (
      <div>
        {this.state.mainLoading && <LinearProgress id="main-loader" />}
        <div>
          <div className="panel panel-default">
            <div className="panel-heading-cpd-3" style={{ padding: "10px" }}>
              <i
                className="fa fa-filter "
                title=""
                data-original-title="Search"
              >
                {" "}
                Search
              </i>
            </div>

            <div className="shadow">
              <div className="layout-gt-sm-row">
                <div style={{ padding: "1rem 1rem" }}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group admin-host-forms">
                        <label>User Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          onChange={(e) => this.searchData(e)}
                          value={this.state.search_name}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group admin-host-forms">
                        <label>Email</label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          value={this.state.search_email}
                          onChange={(e) => this.searchData(e)}
                        />
                      </div>
                    </div>
                  </div>

                  <div>
                    <button
                      className="btn btn-primary"
                      style={{ marginRight: "10px" }}
                    >
                      <span className="glyphicon glyphicon-search"> </span>{" "}
                      Search
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={() => this.clearSearchFilters()}
                    >
                      <span className="glyphicon glyphicon-remove-sign"> </span>{" "}
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="gridTopButtons" style={{ paddingTop: "15px" }}>
            <button
              type="button"
              className="btn btn-primary btn-circle btn-lg "
              onClick={this.modalData}
            >
              <i className="fa fa-plus"> </i>
            </button>
          </div>
        </div>

        <div className="col-table-host">
          {this.state.mainLoading && <Loader />}
          <table className="table table-striped table-hover">
            <thead>
              <tr className="header">
                <th>UserName</th>
                <th>Email</th>
                <th>FirstName</th>
                <th>Surname</th>
                <th>LastLoginTime</th>
                <th>EmployerName</th>
                <th></th>
              </tr>
            </thead>
            <tbody>{loadHost}</tbody>
          </table>
          {loadHost?.length > 0 ? "" : this.state.emptyDivMsg}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user: state,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(removeData()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(UserManagment);
